<template>
  <div class="page-module">
    <mt-popup
      v-model="selfSwitch"
      position="bottom"
      class="bottom-select-popup"
    >
      <div class="inner" @click.stop="">
        <div class="popup-head">
          条件设定
          <span class="howto" @click="openHowto"></span>
        </div>

        <ul class="popup-body">
          <li class="item clearfix" @click="selectNumerical()">
            <span class="cell-title">出现条件</span>
            <div class="cell-value jump-ico elli" v-text="optionVal === null? '请选择': optionVal"></div>
          </li>
          <li class="item clearfix" @click="selectMode()">
            <span class="cell-title">判定方式</span>
            <div class="cell-value jump-ico elli" v-text="modeVal"></div>
          </li>
          <li class="item clearfix" @click="setNum()">
            <span class="cell-title">数值</span>
            <div class="cell-value jump-ico elli" v-text="numValText"></div>
          </li>
        </ul>

        <div v-if="optionVal !== null" class="notice elli">
          当<i class="flag" v-text="optionVal + modeTypes[modeID] + numValText ">）</i>时，剧情出现
        </div>
        <div class="popup-btns">
          <button class="btn" @click="close">取消</button>
          <button class="btn confirm" @click="sub()">确定</button>
        </div>
      </div>
    </mt-popup>

    <rule-popup v-if="rulePopupSwitch" v-bind="rulePopupConf"></rule-popup>
    <radio-popup v-if="radioPopupSwitch" v-bind="radioPopupConf" @close="radioPopupSwitch = false"></radio-popup>
    <prompt-popup v-if="promptPopupSwitch" v-bind="promptPopupConf"></prompt-popup>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import {Methods} from '../const/common';
  import RulePopup from '../components/rule_popup';
  import RadioPopup from '../components/radio_popup';
  import promptPopup from '../components/prompt_popup';

  export default {
    name: "conditions-set",
    components: {
      'rule-popup': RulePopup,
      'radio-popup': RadioPopup,
      'prompt-popup': promptPopup
    },
    props: {
      _switch: Boolean
    },
    computed: {
      ...mapState(['conditionsSwitch', 'conditionsType'])
    },
    data() {
      return {
        selfSwitch: this.conditionsSwitch,
        type: 'new',
        conditionData: null,
        radioChangeIndex: null,
        rulePopupConf: {},
        rulePopupSwitch: false,
        radioPopupConf: {},
        radioPopupSwitch: false,
        optionData: [],
        modes: [
          {tname: '>（大于）', flag: true},
          {tname: '≧（大于等于）', flag: false},
          {tname: '=（等于）', flag: false},
          {tname: '≦（小于等于）', flag: false},
          {tname: '<（小于）', flag: false}
        ],
        modeTypes: ['=', '≧', '≦', '>', '<'],
        promptPopupSwitch: false,
        promptPopupConf: {},
        optionVal: null,
        modeVal: '>（大于）',
        modeID: 3,
        setNumIndexSign: 0,
        optionNum: 0,
        numVal: 0,
        numValText: 0,
        comparisonType: 0,
        decideNumVal: 'fixation',
        conditionArrSign: 0,
        decideNum: [{tname: '与固定数值比较', flag: true, type: 'fixation'}, {tname: '选择已有的数值项进行比较', type: 'existing'}],
      }
    },
    watch: {
      'selfSwitch': function (newVal) {
        store.state.conditionsSwitch = newVal;
      },
      'conditionsSwitch': function (newVal) {
        this.selfSwitch = newVal;
        if (newVal) {
          this.init();

          if (this.conditionsType === 'edit') {
            let oldData = Middle.MiddleData.getConditionData().conditionArr[0];

            this.setNumIndexSign = oldData.numerical1;
            this.modeID = oldData.symbol;
            this.comparisonType = oldData.isNumerical;
            this.numVal = oldData.numerical2;
            this.optionVal = this.optionData[this.setNumIndexSign].numName;
            this.modeVal = (() => {
              switch (this.modeID) {
                case 0:
                  return '=（等于）';
                case 1:
                  return '≧（大于等于）';
                case 2:
                  return '≦（小于等于）';
                case 3:
                  return '>（大于）';
                case 4:
                  return '<（小于）';
              }
            })();
            this.modes.forEach((item) => {
              if (item.tname === this.modeVal) {
                Vue.set(item, 'flag', true);
              } else {
                Vue.set(item, 'flag', false);
              }
            });
            if (this.comparisonType === 0) {
              this.numValText = this.numVal;
            } else {
              this.numValText = this.optionData[this.numVal].numName;
            }

            this.optionData.forEach((item, i) => {
              if (item.numName === this.optionVal) {
                Vue.set(item, 'flag', true);
                this.setNumIndexSign = i;
              } else {
                Vue.set(item, 'flag', false);
              }
            });
          }
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      close() {
        store.state.conditionsSwitch = false;
      },
      init() {
        this.getAllOption();

        let lastSetNumIndex = Middle.ProjectData.lastSetNumber.index,
          lastSetNumName = Middle.ProjectData.lastSetNumber.numName;
        let _this = this;

        if (lastSetNumIndex > -1 && lastSetNumName !== '') {
          this.optionData.forEach(function (_item, i) {
            if (_item.index === lastSetNumIndex) {
              Vue.set(_item, 'flag', true);
              _this.optionVal = _item.numName;
              _this.setNumIndexSign = i;
            }
          });
        }
      },
      initConditionArrSign() {
        Object.assign(this.conditionData, {flag: false});
        Vue.set(this.conditionData.conditionArr[0], 'flag', true);
        this.conditionArrSign = 0;
      },
      initNumVal() {
        this.modeID = 3;
        this.numVal = 0;
        this.numValText = 0;
        this.modeVal = '>（大于）';

        this.modes.forEach(function (_item) {
          Vue.set(_item, 'flag', false);
        });
        Vue.set(this.modes[0], 'flag', true);
        this.decideNum.forEach(function (_item) {
          Vue.set(_item, 'flag', false);
        });
        Vue.set(this.decideNum[0], 'flag', true);

        this.decideNumVal = 'fixation';
        this.comparisonType = 0;
      },
      sub() {
        if (this.optionData.length <= 0 && !this.optionData[this.setNumIndexSign]) {
          return Toast({
            message: '请选择数值项'
          });
        }
        let param = {
          id: 0,
          numerical1: this.setNumIndexSign,
          symbol: this.modeID,
          isNumerical: this.comparisonType,
          numerical2: this.numVal,
        };

        if (this.conditionsType === 'add') {
          Middle.MiddleData.AddConditionForkGroup(param);
        } else if (this.conditionsType === 'edit') {
          Middle.MiddleData.ChangeCondition(0, param);
        }

        this.initNumVal();
        store.state.conditionsSwitch = false;
      },
      delItem() {
        Methods.messageConfirm('', '确认删除该条件吗？', '删除', '再看看', () => {
          Middle.MiddleData.DeleteCondition(this.conditionArrSign);
          this.initConditionArrSign();
        }, () => {
          this.radioPopupSwitch = true;
        })
      },
      setNum() {
        let _this = this;

        this.radioPopupConf = {
          title: '请选择赋值方式',
          options: this.decideNum,
          addItemSwitch: false,
          btnConf: [
            {
              text: '取消',
              callBack: () => {
                _this.radioPopupSwitch = false;
              }
            },
            {
              text: '下一步',
              callBack: () => {
                if (this.decideNumVal === 'fixation') {
                  _this.promptPopupConf = {
                    titleText: '输入想要设置的数值',
                    val: 0,
                    reg: /\D/g,
                    regStr: '',
                    maxLength: 0,
                    placeholder: '请输入数值',
                    inputType: 'number',
                    btnConf: [
                      {
                        text: '上一步',
                        callBack: () => {
                          _this.$nextTick(function () {
                            _this.setNum();
                          });
                          _this.promptPopupSwitch = false;
                        }
                      },
                      {
                        text: '完成',
                        callBack: res => {
                          if (res === '') {
                            return Toast({
                              message: '请输入数值'
                            });
                          }

                          _this.numVal = res;
                          _this.numValText = res;
                          _this.promptPopupSwitch = false;
                        }
                      }
                    ],
                  };
                  _this.radioPopupSwitch = false;
                  _this.promptPopupSwitch = true;
                } else if (this.decideNumVal === 'existing') {
                  let _option = (() => {
                    let _datas = [];

                    _this.optionData.forEach((item) => {
                      if (item.numName !== this.optionVal) {
                        _datas.push(item);
                      }
                    });
                    return _datas;
                  })();

                  let lastSetNumIndex = Middle.ProjectData.lastSetNumber.index,
                    lastSetNumName = Middle.ProjectData.lastSetNumber.numName,
                    flagRes = false;

                  _option = JSON.parse(JSON.stringify(_option));

                  _option.forEach((_item) => {
                    if (_item.numName === this.numValText) {
                      flagRes = true;
                      Vue.set(_item, 'flag', true);
                    } else {
                      Vue.set(_item, 'flag', false);
                    }
                  });

                  if (!flagRes) {
                    _option.forEach((_item) => {
                      if (_item.index === lastSetNumIndex) {
                        Vue.set(_item, 'flag', true);
                      }
                    });
                  }

                  _this.radioPopupConf = {
                    title: '请选择一个数值项选项',
                    options: _option,
                    addItemSwitch: true,
                    valKey: 'showName',
                    btnConf: [
                      {
                        text: '上一步',
                        callBack: () => {
                          _this.$nextTick(function () {
                            _this.setNum();
                          });
                          _this.radioPopupSwitch = false;
                        }
                      },
                      {
                        text: '完成',
                        callBack: () => {
                          let _lock = true;

                          _option.forEach((item) => {
                            if (item.flag) {
                              _lock = false;
                              this.numVal = item.index;
                              this.numValText = item.numName;
                              // Vue.set(item, 'flag', false);
                            }
                          });

                          if (_lock) {
                            Toast({
                              message: '请选择数值项'
                            })
                          } else {
                            this.radioPopupSwitch = false;
                            // Vue.set(_this.optionData[this.setNumIndexSign], 'flag', true);
                          }
                        }
                      }
                    ],
                    radioSelect: (item, index) => {
                      _option.forEach(function (_item) {
                        Vue.set(_item, 'flag', false);
                      });
                      Vue.set(_option[index], 'flag', true);
                    },
                    addItemCallBack: () => {
                      _this.promptPopupConf = {
                        titleText: '添加数值项',
                        val: '',
                        maxLength: 15,
                        placeholder: '请输入条件名称，不超过15个字',
                        btnConf: [
                          {
                            text: '上一步',
                            callBack: () => {
                              _this.promptPopupSwitch = false;
                              _this.radioPopupSwitch = true;
                            }
                          },
                          {
                            text: '添加并使用',
                            callBack: res => {
                              if (res === '') {
                                return Toast({
                                  message: '请输入数值名称！'
                                });
                              }

                              let _lock = false;

                              this.optionData.forEach(function (item) {
                                if (item.numName === res) {
                                  _lock = true;
                                }
                              });
                              if (_lock) {
                                Toast({
                                  message: '当前数值项名称已存在！'
                                });
                              } else {
                                Methods.addNumber(res);
                                this.getAllOption();
                                Vue.set(_this.optionData[this.setNumIndexSign], 'flag', true);
                                this.numVal = this.optionData.length - 1;
                                this.numValText = res;
                                this.promptPopupSwitch = false;
                              }
                            }
                          }
                        ],
                      };
                      _this.radioPopupSwitch = false;
                      _this.promptPopupSwitch = true;
                    }
                  };
                }
              }
            }
          ],
          radioSelect: (item, index) => {
            _this.decideNum.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(_this.decideNum[index], 'flag', true);
            _this.decideNumVal = _this.decideNum[index].type;
            this.comparisonType = _this.decideNumVal === 'fixation' ? 0 : 1;
          }
        };
        this.radioPopupSwitch = true;
      },
      selectMode() {
        this.radioPopupConf = {
          title: '请选择赋值方式',
          options: this.modes,
          btnLock: false,
          addItemSwitch: false,
          radioSelect: (item, index) => {
            this.modes.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(this.modes[index], 'flag', true);
            this.modeVal = item.tname;
            if (item.tname === '=（等于）') {
              this.modeID = 0;
            } else if (item.tname === '≧（大于等于）') {
              this.modeID = 1;
            } else if (item.tname === '≦（小于等于）') {
              this.modeID = 2;
            } else if (item.tname === '>（大于）') {
              this.modeID = 3;
            } else if (item.tname === '<（小于）') {
              this.modeID = 4;
            }
            this.radioPopupSwitch = false;
          },
          cancel: () => {
            this.radioPopupSwitch = false;
          },
          confirm: res => {
          }
        };
        this.radioPopupSwitch = true;
      },
      getAllOption() {
        this.optionData = [].concat(JSON.parse(JSON.stringify(Middle.MiddleData.getAllNumber())));
        this.radioPopupConf.options = this.optionData;
      },
      openHowto() {
        this.rulePopupConf = {
          title: '什么是条件设定？',
          desc: [
            '条件设定的目的，是控制对话、旁白在条件不满足的情况下不出现，也就是说，只有设置的所有条件都满足，设定条件的条目才会在剧情中出现；',
            '一次条件分歧判断中，最多只能设置5个条件，可以通过多个条件来制造条件数值区间；',
            '例如，若一次条件分歧判断中设置了[005]女主角好感大于5，即意味着当[005]女主角好感数值大于5时，才会进入“满足条件的剧情”，否则，将进入“不满足条件的剧情”。'
          ],
          cancelCallBack: () => {
            this.rulePopupSwitch = false;
          }
        };
        this.rulePopupSwitch = true;
      },
      selectNumerical() {
        this.radioPopupConf = {
          title: '选择一个数值项',
          options: this.optionData,
          editSwitch: true,
          addItemSwitch: true,
          valKey: 'showName',
          btnConf: [
            {
              text: '确定',
              callBack: () => {
                this.optionData.forEach((_item, i) => {
                  if (_item.flag) {
                    this.optionVal = _item.numName;

                    if (this.optionData[this.setNumIndexSign].numName !== _item.numName) {
                      this.setNumIndexSign = i;
                      this.initNumVal();
                    }
                  }
                });
                this.radioPopupSwitch = false;
              }
            }
          ],
          radioSelect: (item, index) => {
            this.optionData.forEach(function (_item) {
              Vue.set(_item, 'flag', false);
            });
            Vue.set(this.optionData[index], 'flag', true);
          },
          addItemCallBack: () => {
            this.promptPopupConf = {
              titleText: '添加数值项',
              val: '',
              maxLength: 15,
              affirmBtnText: '添加',
              placeholder: '请输入数值名称，不超过15个字',
              btnConf: [
                {
                  text: '取消',
                  callBack: () => {
                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                },
                {
                  text: '添加',
                  callBack: res => {
                    if (res === '') {
                      return Toast({
                        message: '请填写数值名称！'
                      });
                    }

                    let _flagItem = null, _lock = false;

                    this.optionData.forEach(function (item) {
                      if (item.flag) {
                        _flagItem = item;
                      }
                      if (item.numName === res) {
                        _lock = true;
                        Toast({
                          message: '当前数值项名称已存在！ '
                        });
                      }
                    });
                    if (_lock) {
                      return false;
                    }

                    Methods.addNumber(res);
                    this.getAllOption();
                    if (_flagItem !== null) {
                      Vue.set(_flagItem, 'flag', false);
                    }
                    Vue.set(this.optionData[this.optionData.length - 1], 'flag', true);
                    this.radioPopupConf.options = this.optionData;
                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                }
              ]
            };

            this.radioPopupSwitch = false;
            this.promptPopupSwitch = true;
          },
          edit: (itemIndex, numIndex) => {
            let _this = this;

            this.promptPopupConf = {
              titleText: '编辑数值项',
              val: this.optionData[itemIndex].numName,
              maxLength: 15,
              btnConf: [
                {
                  text: '取消',
                  callBack: () => {
                    this.promptPopupSwitch = false;
                    this.radioPopupSwitch = true;
                  }
                },
                {
                  text: '保存',
                  callBack: res => {
                    if (res === '') {
                      return Toast({
                        message: '请填写数值名称！'
                      });
                    }

                    let _editLock = false;

                    for (let _i = 0; _i < _this.optionData.length; _i++) {
                      if (_this.optionData[_i].numName === res && _this.optionData[_i].index !== numIndex) {
                        _editLock = true;
                        break;
                      }
                    }

                    if (_editLock) {
                      Toast({
                        message: '当前数值项名称已存在！'
                      });
                    } else {
                      Middle.MiddleData.setNumberData(itemIndex, res);
                      _this.getAllOption();
                      Vue.set(_this.optionData[itemIndex], 'flag', true);
                      _this.promptPopupSwitch = false;
                      _this.radioPopupSwitch = true;
                    }
                  }
                }
              ]
            };

            this.radioPopupSwitch = false;
            this.promptPopupSwitch = true;
            this.radioChangeIndex = i;
          },
        };
        this.radioPopupSwitch = true;
      },
    }
  }
</script>

<style scoped>
  @import "../style/css/bottom_select_popup.css";
</style>



// WEBPACK FOOTER //
// src/components/conditionsSet.vue